import { Icon, MenuItem } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';
import { SurveyService } from '../services/SurveyService';

export const MenuItemOpenSharePoint = (props: {
  relativeUrl: string,
}) => {

  return (
    <MenuItem onClick={() => SurveyService.openSharePoint(props.relativeUrl)} icon={<Icon as={FiExternalLink} />} >Open in SharePoint</MenuItem>
  )
}
